<template>
    <d2-container>
        <h2>撬装设备列表</h2>
        <el-form ref="elForm" :model="formData" size="medium" label-width="100px">
            <el-row>
                <el-form-item label="撬装设备编码" prop="dd">
                    <el-input v-model="listQuery.oilEdequipmentCode" placeholder="撬装设备编码" clearable
                        :style="{ width: '763px' }"></el-input>
                </el-form-item>
            </el-row>
            <el-form-item size="large">
                <el-button size="small" class="filter-item" type="primary" icon="search"
                    @click="handleFilter">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>


        <!--表格-->
        <el-button size="small" class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
            icon="edit">新增撬装设备</el-button>
        <el-button size="small" class="filter-item" style="margin-left: 10px;" @click="exportData('a', '撬装设备列表.csv')"
            type="primary" icon="edit">导出全部数据</el-button>
        <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row
            style="width: 100%">

            <el-table-column prop="oilEdequipmentCode" label="撬装设备编码" width="150">
            </el-table-column>
            <el-table-column prop="entName" label="用油企业" width="180">
            </el-table-column>
            <el-table-column prop="addressStreetName" label="所在街镇" width="180">
            </el-table-column>
            <el-table-column prop="oilEdequipmentAddress" label="设立地址" width="180">
            </el-table-column>
            <el-table-column prop="filingNo" label="备案编号">
            </el-table-column>
            <el-table-column prop="inventoryVolume" label="库存量（L）" width="100">
            </el-table-column>
            <el-table-column label="实时监控">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" v-if="scope.row.liveChannelId"
                        @click="livePreview(scope.row.liveChannelId)">查看监控</a>
                    <span v-else>未绑定</span>
                </template>
            </el-table-column>
            <el-table-column label="启用状态" width="80">
                <template slot-scope="scope">{{ scope.row.enableStatus == 1 ? '启用' : '停用' }}</template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="220">
                <template slot-scope="scope">
                    <el-button size="small" @click="handleClick(scope.row)">查看</el-button>
                    <el-button size="small" type="success" @click="handleUpdate(scope.row)">编辑</el-button>
                    <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->
        <template slot="footer">
            <div v-show="!listLoading" class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
            </div>
        </template>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" :key="'form' + dialogFormVisible">
            <el-form :model="form" :rules="rules" ref="form" label-width="120px">
                <el-form-item label="撬装设备编码" prop="oilEdequipmentCode" required>
                    <el-input v-model="form.oilEdequipmentCode" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="设立地址" prop="oilEdequipmentAddress" required>
                    <el-input v-model="form.oilEdequipmentAddress" placeholder="请输入" @focus="mapShow = true"></el-input>
                </el-form-item>
                <el-form-item label="GIS选址">
                    <span v-if="!mapShow">{{ form.latitude ? '已采集, 坐标:' + form.longitude + ", " + form.latitude : '未采集'
                    }}</span>
                    <div style="width:100%;height:420px;overflow:hidden;" v-if="mapShow">
                        <Map :address="form.oilEdequipmentAddress" v-model="mapVo" :key="mapShow"
                            @changeInfo="mapFinish"></Map>
                    </div>
                </el-form-item>
                <el-form-item label="备案编号">
                    <el-input v-model="form.filingNo" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="停车场编码">
                    <el-input v-model="form.enterChannelCustomCode" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="视频通道ID" v-if="entType == '3'">
                    <el-select v-model="form.liveChannelId" filterable placeholder="请选择" style="width:100%">
                        <el-option v-for="(item, index) in liveList" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="库存量（升L）">
                    <el-input v-model="form.inventoryVolume" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="油罐容量（升L）">
                    <el-input v-model="form.capacityVolume" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="安评到期时间">
                    <el-date-picker v-model="form.safetyOutTime" type="month" placeholder="选择日期"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="防雷到期时间">
                    <el-date-picker v-model="form.thunderOutTime" type="month" placeholder="选择日期"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="启用状态">
                    <el-switch v-model="form.enableStatus" active-color="#13ce66" inactive-color="#ff4949" :active-value="1"
                        :inactive-value="0">
                    </el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel('form')" size="small">取 消</el-button>
                <el-button v-if="dialogStatus == 'create'" size="small" type="primary"
                    @click="create('form')">保存</el-button>
                <el-button v-if="dialogStatus == 'update'" type="primary" size="small"
                    @click="update('form')">更新</el-button>
            </div>
        </el-dialog>



        <el-drawer title="实时视频预览" :visible.sync="drawerLive" :key="drawerLive" direction="rtl" :before-close="liveClose"
            size="800px">
            <div style="padding-top:0px">
                <hkWebLive ref="liveWindow" :liveChannelId="liveChannelId"></hkWebLive>
            </div>
        </el-drawer>

    </d2-container>
</template>


<script>
import {
    pageList,
    addObj,
    getObj,
    delObj,
    putObj
} from '@/api/admin/sysOilEdequipment/index';
import { exportCsv } from '../../../api/admin/sysOilEdequipment';
import { mapState, mapGetters, mapActions } from 'vuex'
import { liveInfo, liveList } from "../../../api/admin/common";
import { queryStatus } from "../../../api/admin/sysEnterprise/index";
import hkWebLive from "../../index/hkWebLive.vue";
import Map from "../../components/map.vue";
export default {
    name: 'sysBaseMaterial',
    components: { hkWebLive, Map },
    data() {
        return {
            mapShow: false,
            mapVo: {
                point: {}
            },

            dialogFormVisible: false,
            list: null,
            total: null,
            listLoading: true,
            listQuery: {
                page: 1,
                limit: 20,
                oilEdequipmentCode: null
            },
            dialogStatus: '',
            textMap: {
                view: '查看',
                update: '编辑',
                create: '创建'
            },
            tableKey: 0,
            form: {
                oilid: null,
                oilEdequipmentCode: null,
                entId: null,
                devId: null,
                oilEdequipmentAddress: null,
                filingNo: null,
                enterChannelCustomCode: null,
                liveChannelId: null,
                longitude: null,
                latitude: null,
                enableStatus: null,
                acquisitionType: null,
                oilType: 1,
                inventoryVolume: null,
                inventoryWeight: null,
                capacityVolume: null,
                isDel: null,
                addTime: null,
                lastTime: null,
                thunderOutTime: null,
                safetyOutTime: null,
            },
            oilTypes: [
                { value: 0, label: '汽油' },
                { value: 1, label: '柴油' },
            ],
            rules: {
                oilEdequipmentCode: [
                    {
                        required: true,
                        message: '请输入撬装设备编码',
                        trigger: 'blur'
                    }
                ],
                oilEdequipmentAddress: [
                    {
                        required: true,
                        message: '请输入设立地址',
                        trigger: 'blur'
                    }
                ],

            },
            formData: {},
            liveList: [],
            entType: null,
            drawerLive: false,
            liveChannelId: null
        }
    },
    created() {
        this.getList();
        this.queryLiveList();
        this.queryEntStatus();
    },
    computed: {
        ...mapGetters([
            'elements'
        ]),
        ...mapState('d2admin/user', ['info']),
    },
    methods: {
        mapFinish({ point, area }) {
            this.form.longitude = point.lng;
            this.form.latitude = point.lat;
            this.mapShow = false;
        },
        exportData(type, fileName) {
            exportCsv(type, fileName);
        },
        getList() {
            this.listLoading = true;
            pageList(this.listQuery).then(response => {
                this.list = response.rows;
                this.total = response.total;
                this.listLoading = false;
            })
        },
        queryLiveList() {
            liveList().then(response => {
                this.liveList = response.map(x => {
                    return { "label": x.address + " " + x.channelName, "value": x.deviceSerial };
                });
            });
        },
        queryEntStatus() {
            queryStatus().then(response => {
                this.entType = response.entType;
            });
        },
        handleFilter() {
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        handleCreate() {
            this.resetTemp();
            this.dialogStatus = 'create';
            this.mapShow = false;
            this.dialogFormVisible = true;
        },
        handleClick(row) {
            getObj(row.oilid)
                .then(response => {
                    this.form = response;
                    this.dialogFormVisible = true;
                    this.mapShow = false;
                    this.dialogStatus = 'view';
                    if (this.form.longitude && this.form.latitude) {
                        this.mapVo = {
                            point: { lng: this.form.longitude, lat: this.form.latitude },
                        }
                    }
                });
        },
        handleUpdate(row) {
            getObj(row.oilid)
                .then(response => {
                    this.form = response;
                    this.dialogFormVisible = true;
                    this.mapShow = false;
                    this.dialogStatus = 'update';
                    if (this.form.longitude && this.form.latitude) {
                        this.mapVo = {
                            point: { lng: this.form.longitude, lat: this.form.latitude },
                        }
                    }
                });
        },
        handleDelete(row) {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    delObj(row.oilid)
                        .then(() => {
                            this.$notify({
                                title: '成功',
                                message: '删除成功',
                                type: 'success',
                                duration: 2000
                            });
                            const index = this.list.indexOf(row);
                            this.list.splice(index, 1);
                        });
                });
        },
        create(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    addObj(this.form)
                        .then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        })
                } else {
                    return false;
                }
            });
        },
        cancel(formName) {
            this.dialogFormVisible = false;
            const set = this.$refs;
            set[formName].resetFields();
        },
        update(formName) {
            const set = this.$refs;
            set[formName].validate(valid => {
                if (valid) {
                    this.dialogFormVisible = false;
                    putObj(this.form.oilid, this.form).then(() => {
                        this.dialogFormVisible = false;
                        this.getList();
                        this.$notify({
                            title: '成功',
                            message: '创建成功',
                            type: 'success',
                            duration: 2000
                        });
                    });
                } else {
                    return false;
                }
            });
        },
        resetTemp() {
            this.form = {
                oilid: null,
                oilEdequipmentCode: null,
                entId: null,
                devId: null,
                oilEdequipmentAddress: null,
                filingNo: null,
                enterChannelCustomCode: null,
                liveChannelId: null,
                longitude: null,
                latitude: null,
                enableStatus: null,
                acquisitionType: null,
                oilType: 1,
                inventoryVolume: null,
                inventoryWeight: null,
                capacityVolume: null,
                isDel: null,
                addTime: null,
                lastTime: null,
                thunderOutTime: null,
                safetyOutTime: null,
            };
        },
        resetForm() {
            this.listQuery = {
                page: 1,
                limit: 20,
                oilEdequipmentCode: null
            }
        },
        livePreview: function (liveChannelId) {
            this.drawerLive = true;
            this.liveChannelId = liveChannelId;
        },
        liveClose() {
            this.drawerLive = false;
            this.$refs.liveWindow.stop();

            console.log("close.")
        },
    }
}
</script>

